var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel",attrs:{"id":"panel-shop"}},[_c('h3',[_vm._v("Quick upgrades")]),_vm._l((_vm.items),function(item,key){return (item.quickshop)?_c('ShopItem',{attrs:{"shopItem":item,"quickshop":"true"}}):_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }